module.exports = __webpack_public_path__ + "media/images/top/pap/common/img_point01-ba9d884b4115ba99b66146027c1bb088.png";